import { getInstances } from '../configure';

export function withInstance(callback) {
  const instances = getInstances();
  if (instances?.analytics) {
    return callback(instances.analytics);
  }
}
